// Copyright © Paladin Projects LLC, 2026

import { lazy } from 'react';
import { Route, Routes } from 'react-router';

const LoginPage = lazy(() => import('@pages/LoginPage').then(module => ({ default: module.LoginPage })));
const MainPage = lazy(() => import('@pages/MainPage').then(module => ({ default: module.MainPage })));
const DocumentsPage = lazy(() => import('@pages/DocumentsPage').then(module => ({ default: module.DocumentsPage })));
const MainLayout = lazy(() => import('@widgets/MainLayout').then(module => ({ default: module.MainLayout })));

export const AppRoutes = () => {
    
  return (
    <Routes>
      <Route path="/login"
        element={<LoginPage />}
      />
      <Route path="/"
        element={<MainLayout />}
      >
        <Route index
          element={<MainPage />}
        />
        <Route path="thread/:threadId"
          element={<MainPage />}
        />
        <Route path="documents"
          element={<DocumentsPage />}
        />
      </Route>
    </Routes>
  );
};